import { useState } from 'react';
import { useSelector } from 'react-redux';
import {
  collection,
  query,
  where,
  getDocs,
  doc,
  setDoc,
  addDoc,
} from 'firebase/firestore';
import { db } from '@/app/firebase/config'; // Adjust path as needed

export default function useFBGymAddresses() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const basketID = useSelector((state) => state.basket.basketData.basketID);
  const delivery = useSelector((state) => state.basket.deliveryData);
  const billing = useSelector((state) => state.basket.billingData);

  const FBGymAddresses = async (collectionName) => {
    setLoading(true);
    setError(null);

    try {
      // Validate inputs
      if (!basketID) {
        throw new Error(
          'basketID is undefined. Ensure it is set in Redux before calling this function.'
        );
      }

      if (
        !collectionName ||
        !['delivery', 'billing'].includes(collectionName)
      ) {
        throw new Error(
          'Invalid collection provided. Must be "delivery" or "billing".'
        );
      }

      // Select the appropriate data based on the collection
      const addressData = collectionName === 'delivery' ? delivery : billing;

      // Prepare the document data
      const addressDataIncID = {
        ...addressData,
        basketID, // Include basketID
      };

      // Query Firestore for an existing document with the same basketID
      const collectionRef = collection(db, collectionName);
      const querySnapshot = await getDocs(
        query(collectionRef, where('basketID', '==', basketID))
      );

      if (!querySnapshot.empty) {
        // Document with the same basketID exists, update it
        const existingDoc = querySnapshot.docs[0];
        const existingDocRef = doc(db, collectionName, existingDoc.id);

        await setDoc(existingDocRef, addressDataIncID, { merge: true }); // Update existing document
        console.log(
          `Document updated in "${collectionName}" with ID: ${existingDoc.id}`
        );
        return existingDoc.id; // Return the existing document ID
      } else {
        // No matching document found, create a new one
        const newDocRef = await addDoc(collectionRef, addressDataIncID);
        console.log(
          `Document added to "${collectionName}" with ID: ${newDocRef.id}`
        );
        return newDocRef.id; // Return the new document ID
      }
    } catch (err) {
      console.error('Error updating Firebase gym data:', err.message);
      setError(err.message);
      throw err; // Re-throw the error for handling in the calling component
    } finally {
      setLoading(false);
    }
  };

  return { FBGymAddresses, loading, error };
}
